import type { DirectiveBinding } from "vue"

interface ExtendedHTMLElement extends HTMLElement {
  _clickOutside?: (event: MouseEvent) => void
}

export const vClickOutside = {
  mounted(el: ExtendedHTMLElement, binding: DirectiveBinding) {
    el._clickOutside = (event: MouseEvent) => {
      if (!(el === event.target || el.contains(event.target as Node))) {
        binding.value?.(event)
      }
    }
    document.addEventListener("click", el._clickOutside, true)
  },

  unmounted(el: ExtendedHTMLElement) {
    if (el._clickOutside) {
      document.removeEventListener("click", el._clickOutside, true)
      delete el._clickOutside
    }
  },
}
